import React from 'react';
import cx from 'classnames';
import { PriceTransparencyRating, RatingMap } from './PriceTransparencyRating';
import styles from './PriceTransparencyBadge.module.css';
const PriceTransparencyBadge = ({ className, label, rating = PriceTransparencyRating.NO_DATA }) => {
    var _a;
    return (React.createElement("span", { className: cx(styles.component, className, (_a = styles[RatingMap[rating]]) !== null && _a !== void 0 ? _a : styles['no-data']) }, label));
};
export default PriceTransparencyBadge;
//# sourceMappingURL=PriceTransparencyBadge.js.map